// assets
import { Draw, Archive, Folder } from '@mui/icons-material';
import { UserProjectIcon } from 'components/icons/sidebarIcons';
// constant
export const icons = {
    Folder,
    Draw,
    Archive
};

const userProject = {
    id: 'user-project',
    title: 'side_menu.project_manager',
    type: 'group',
    roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
    collapse: false,
    icon: 'Folder', //icons.Folder,
    children: [
        {
            id: 'user-project-list',
            title: 'side_menu.project_list',
            type: 'item',
            url: 'user-project/list',
            icon: 'Draw', //icons.Draw,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'user-project-archive',
            title: 'side_menu.project_archive',
            type: 'item',
            url: 'user-project/archive',
            icon: 'Archive', //icons.Archive,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        }
    ]
};

export default userProject;
